import { Button, Card, Empty } from "antd"
import { RecordNotFound } from "../../../components/RecordNotFound/RecordNotFound.tsx"
import { RoutesPaths } from "../../../constants/routes.ts"
import React from "react"
import { useTranslation } from "react-i18next"

interface LeadLoadFailureProps {
  notFound?: boolean
  retrying?: boolean
  onRetry: () => void
}

/**
 * Only a 404 says the lead is gone. Every other failed read is offered a retry,
 * so a token that expired or a dropped request does not strand a lead that is
 * still there.
 */
function LeadLoadFailure({
  notFound,
  retrying,
  onRetry
}: LeadLoadFailureProps) {
  const { t } = useTranslation()

  if (notFound) {
    return (
      <RecordNotFound
        titleKey={"leadLoad.notFound"}
        backTo={RoutesPaths.lead.list}
        backLabelKey={"recordNotFound.lead.back"}
      />
    )
  }

  return (
    <Card size={"small"}>
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={t(notFound ? "leadLoad.notFound" : "leadLoad.failed")}
      >
        {!notFound && (
          <Button type={"primary"} loading={retrying} onClick={onRetry}>
            {t("leadLoad.retry")}
          </Button>
        )}
      </Empty>
    </Card>
  )
}

export { LeadLoadFailure }
